export default {
  driver_performance_driver_filters_timeFrame: "Timeframe",
  driver_performance_driver_filters_events: "Events",
  driver_performance_driver_filters_drivers: "Drivers",
  driver_performance_driver_filters_tags: "Tags",
  driver_performance_driver_filters_configuring: "Configuring",
  driver_performance_driver_filters_riskScore: "Risk Score",
};